import { forwardRef, Children, useId } from 'react';
import { ArrayKit } from '@team/array';
import { CommonUi } from '@team/common-ui';
import { Props } from './types';
import { isAvatarComponent } from './model';
import { Layout } from './layout';
import { StackElement } from './components/stack-element';

export const Entry = forwardRef<HTMLDivElement, Props>(function Component(
  { children, size = 28, visibleCount = 3, ...props },
  forwardedRef
) {
  const uniqueId = useId();

  const validatedChildrens = Children.toArray(children)
    .filter(isAvatarComponent)
    .slice(ArrayKit.HEAD_ELEMENT_INDEX, visibleCount);

  return (
    <Layout {...props} rootRef={forwardedRef}>
      <CommonUi.ArrayOf
        data={validatedChildrens}
        Component={StackElement}
        mapToProps={(children, place) => ({ uniqueId, place, size, children })}
      />
    </Layout>
  );
});
